import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DisclaimerProvider } from './components/DisclaimerModal';
import RetirementCalculator from './components/RetirementCalculator';

function App() {
  return (
    <BrowserRouter>
      <DisclaimerProvider>
        <Routes>
          <Route path="/" element={<RetirementCalculator />} />
        </Routes>
      </DisclaimerProvider>
    </BrowserRouter>
  );
}

export default App;
